export default {
  getSignedURL (vm, file, name) {
    let endpoint = 'https://2o0buzzfdk.execute-api.eu-west-2.amazonaws.com/prod/getSignedUrl'
    let payload = {
      filePath: name,
      contentType: file.type
    }

    return vm.$http.post(endpoint, payload, {
      headers: {
        'x-api-key': 'Yxri8foPU242Ahe64FK192bzTWMLfcro2JbmLPyS'
      }
    })
      .then((res) => {
        return Promise.resolve(res.bodyText)
      })
      .catch((err) => {
        console.error(err)
        return Promise.resolve('/')
      })
  }
}



// WEBPACK FOOTER //
// ./src/lambda.js